/*
 * Reputon-Google-Bewertungen: bedarfsgerecht laden statt auf jeder Seite.
 * Angelegt 2026-07-30 (Felix).
 *
 * Ausgangslage: Das Widget-Script (101 kB) wurde ueber einen Legacy-ScriptTag
 * auf JEDER Seite geladen — auch dort, wo gar kein Container existiert. Auf
 * moebel-peeck.de betraf das nahezu jede Seite. Sobald das Widget wirklich
 * rendert, holt es zusaetzlich Manrope von fonts.googleapis.com und
 * fonts.gstatic.com (~25 kB, zwei Google-Hosts).
 *
 * Dieses Script uebernimmt die Rolle des ScriptTags:
 *   - Seite ohne .reputon-google-reviews-widget  -> es wird gar nichts geladen.
 *   - Seite mit Container                        -> geladen, sobald der Nutzer
 *     in die Naehe scrollt, spaetestens bei der ersten Interaktion oder im
 *     Leerlauf. Nie im kritischen Renderpfad.
 *
 * Zwei Fallstricke, die hier bewusst abgefangen werden:
 *
 * 1) Solange der alte ScriptTag noch existiert, wuerde das Widget doppelt
 *    geladen. Deshalb prueft injizieren() zuerst, ob bereits ein
 *    grw.reputon.com-Script im Dokument haengt, und tut dann nichts.
 *    Dieses Script ist also so lange inert, bis der ScriptTag entfernt ist.
 *
 * 2) Der Container meldet in manchen Umgebungen Breite 0. Ein Element ohne
 *    Flaeche loest im IntersectionObserver nie ein Intersection-Ereignis aus —
 *    ein frueherer Anlauf ist genau daran gescheitert. Deshalb ist der
 *    Observer nur der Normalweg; zusaetzlich greifen erste Nutzerinteraktion
 *    und ein Leerlauf-Timer. Das Widget erscheint damit in jedem Fall.
 *
 * Geprueft: Das Widget rendert auch dann noch, wenn Container und Script erst
 * nachtraeglich ins Dokument kommen — es sucht seine Container bei der
 * Ausfuehrung, nicht nur beim DOMContentLoaded.
 *
 * Dieselbe Datei laeuft auf beiden Shops; die Shop-Domain kommt aus dem von
 * Shopify gesetzten window.Shopify.shop.
 */
(function () {
  'use strict';

  var shop = (window.Shopify && window.Shopify.shop) || location.hostname;
  var QUELLE = 'https://cdn.grw.reputon.com/assets/widget.js?shop=' + encodeURIComponent(shop);
  var AUSWAHL = '.reputon-google-reviews-widget';
  var LEERLAUF_MS = 2500;

  var erledigt = false;
  var aufraeumen = [];

  function bereitsGeladen() {
    return !!document.querySelector('script[src*="grw.reputon.com"]');
  }

  function injizieren() {
    if (erledigt) return;
    erledigt = true;
    for (var i = 0; i < aufraeumen.length; i++) {
      try { aufraeumen[i](); } catch (e) {}
    }
    aufraeumen.length = 0;
    if (bereitsGeladen()) return;
    var s = document.createElement('script');
    s.src = QUELLE;
    s.async = true;
    document.head.appendChild(s);
  }

  function start() {
    if (!document.querySelector(AUSWAHL)) return;
    var ziele = document.querySelectorAll(AUSWAHL);

    // Normalweg: laden, sobald ein Container in Sichtnaehe kommt.
    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (eintraege[i].isIntersecting) { injizieren(); return; }
        }
      }, { rootMargin: '600px 0px' });
      for (var i = 0; i < ziele.length; i++) io.observe(ziele[i]);
      aufraeumen.push(function () { io.disconnect(); });
    }

    // Auffangnetz 1: erste Nutzerinteraktion.
    var ereignisse = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    function beiInteraktion() { injizieren(); }
    for (var j = 0; j < ereignisse.length; j++) {
      window.addEventListener(ereignisse[j], beiInteraktion, { once: true, passive: true });
    }
    aufraeumen.push(function () {
      for (var k = 0; k < ereignisse.length; k++) {
        window.removeEventListener(ereignisse[k], beiInteraktion);
      }
    });

    // Auffangnetz 2: Leerlauf. Falls der Nutzer nichts tut, laedt das Widget
    // trotzdem — nur eben spaet und ohne den Erstaufbau zu bremsen.
    var timer = setTimeout(injizieren, LEERLAUF_MS);
    aufraeumen.push(function () { clearTimeout(timer); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
